import { Component } from 'react';
import { PropTypes } from 'prop-types';

export default class Step extends Component {
  constructor() {
    super();
    this.getStyles = this.getStyles.bind(this);
  }

  getStyles() {
    const {
      activeColor,
      completeColor,
      defaultColor,
      circleFontColor,
      activeCircleFontColor,
      completeCircleFontColor,
      activeTitleColor,
      completeTitleColor,
      defaultTitleColor,
      size,
      circleFontSize,
      titleFontSize,
      circleTop,
      titleTop,
      width,
      completeOpacity,
      activeOpacity,
      defaultOpacity,
      completeTitleOpacity,
      activeTitleOpacity,
      defaultTitleOpacity,
      barStyle,
      defaultBarColor,
      completeBarColor,
      activeBarColor,
      defaultBorderColor,
      completeBorderColor,
      activeBorderColor,
      defaultBorderStyle,
      completeBorderStyle,
      activeBorderStyle,
      lineMarginOffset,
      defaultBorderWidth
    } = this.props;

    return {
      step: {
        width: `${width}%`,
        display: 'table-cell',
        position: 'relative',
        paddingTop: circleTop
      },
      circle: {
        width: size,
        height: size,
        margin: '0 auto',
        backgroundColor: defaultColor,
        borderRadius: '50%',
        textAlign: 'center',
        padding: 1,
        fontSize: circleFontSize,
        color: circleFontColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: defaultOpacity,
        borderWidth: defaultBorderColor ? defaultBorderWidth : 0,
        borderColor: defaultBorderColor,
        borderStyle: defaultBorderStyle
      },
      activeCircle: {
        backgroundColor: activeColor,
        opacity: activeOpacity,
        borderWidth: activeBorderColor ? defaultBorderWidth : 0,
        borderColor: activeBorderColor,
        borderStyle: activeBorderStyle
      },
      completedCircle: {
        backgroundColor: completeColor,
        opacity: completeOpacity,
        borderWidth: completeBorderColor ? defaultBorderWidth : 0,
        borderColor: completeBorderColor,
        borderStyle: completeBorderStyle
      },
      index: {
        color: circleFontColor
      },
      activeIndex: {
        color: activeCircleFontColor
      },
      completedIndex: {
        color: completeCircleFontColor
      },
      titlesBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
      },
      secondTitleStyle: {
        color: '#6D7175',
        fontSize: '16px',
        paddingLeft: '25px',
        paddingRigth: '25px'
      },
      title: {
        marginTop: titleTop,
        fontSize: titleFontSize,
        fontWeight: '300',
        textAlign: 'center',
        display: 'block',
        color: defaultTitleColor,
        opacity: defaultTitleOpacity
      },
      activeTitle: {
        color: activeTitleColor,
        opacity: activeTitleOpacity
      },
      completedTitle: {
        color: completeTitleColor,
        opacity: completeTitleOpacity
      },
      leftBar: {
        position: 'absolute',
        top: circleTop + size / 2,
        height: 1,
        borderTopStyle: barStyle,
        borderTopWidth: 2,
        borderTopColor: defaultBarColor,
        left: 0,
        right: '50%',
        marginRight: size / 2 + lineMarginOffset,
        opacity: defaultOpacity
      },
      rightBar: {
        position: 'absolute',
        top: circleTop + size / 2,
        height: 1,
        borderTopStyle: barStyle,
        borderTopWidth: 2,
        borderTopColor: defaultBarColor,
        right: 0,
        left: '50%',
        marginLeft: size / 2 + lineMarginOffset,
        opacity: defaultOpacity
      },
      completedBar: {
        borderTopStyle: barStyle,
        borderTopWidth: 2,
        borderTopColor: completeBarColor,
        opacity: completeOpacity
      },
      activeBar: {
        borderTopStyle: barStyle,
        borderTopWidth: 2,
        borderTopColor: activeBarColor,
        opacity: completeOpacity
      }
    };
  }

  render() {
    const { title, secondTitle, icon, index, active, completed, first, isLast, href, onClick } =
      this.props;

    const styles = this.getStyles();
    const circleStyle = Object.assign(
      styles.circle,
      completed ? styles.completedCircle : {},
      active ? styles.activeCircle : {}
    );
    const titleStyle = Object.assign(
      styles.title,
      completed ? styles.completedTitle : {},
      active ? styles.activeTitle : {}
    );
    const indexStyle = Object.assign(
      styles.index,
      completed ? styles.completedIndex : {},
      active ? styles.activeIndex : {}
    );
    const leftStyle = Object.assign(styles.leftBar, active || completed ? styles.completedBar : {});
    const rightStyle = Object.assign(styles.rightBar, completed ? styles.completedBar : {});

    const stepContent = icon ? <img src={icon} alt={index + 1} /> : index + 1;

    return (
      <div style={styles.step}>
        <div style={circleStyle}>
          {active || completed ? (
            <a href={href} onClick={onClick} style={indexStyle}>
              {stepContent}
            </a>
          ) : (
            <span style={indexStyle}>{stepContent}</span>
          )}
        </div>
        {active || completed ? (
          <div style={styles.titlesBox}>
            <a href={href} onClick={onClick} style={titleStyle}>
              {title}
            </a>
            <div style={styles.secondTitleStyle}>{secondTitle}</div>
          </div>
        ) : (
          <div style={styles.titlesBox}>
            <div style={titleStyle}>{title}</div>
            <div style={styles.secondTitleStyle}>{secondTitle}</div>
          </div>
        )}
        {!first && <div style={leftStyle}></div>}
        {!isLast && <div style={rightStyle}></div>}
      </div>
    );
  }
}

Step.defaultProps = {
  activeColor: '#FAFBFB',
  completeColor: '#005359',
  defaultColor: '#F6F6F7',
  activeTitleColor: '#2F6E63',
  completeTitleColor: '#005359',
  defaultTitleColor: '#757575',
  circleFontColor: '#8C9196',
  activeCircleFontColor: '#007D6F',
  completeCircleFontColor: 'white',
  completeBarColor: '#005359',
  defaultBarColor: '#D2D5D8',
  activeBorderColor: '#007D6F',
  completeBorderColor: '#005359',
  defaultBorderColor: '#C9CCCF',
  activeBarColor: '#2F6E63',
  size: 50,
  circleFontSize: 20,
  titleFontSize: 20,
  circleTop: 24,
  titleTop: 12,
  barStyle: 'solid',
  borderStyle: 'solid',
  lineMarginOffset: 20,
  defaultBorderWidth: 2
};

Step.propTypes = {
  width: PropTypes.number.isRequired,
  activeColor: PropTypes.string,
  completeColor: PropTypes.string,
  defaultColor: PropTypes.string,
  activeTitleColor: PropTypes.string,
  completeTitleColor: PropTypes.string,
  defaultTitleColor: PropTypes.string,
  circleFontColor: PropTypes.string,
  size: PropTypes.number,
  circleFontSize: PropTypes.number,
  titleFontSize: PropTypes.number,
  circleTop: PropTypes.number,
  titleTop: PropTypes.number,
  title: PropTypes.string,
  index: PropTypes.number,
  active: PropTypes.bool,
  completed: PropTypes.bool,
  first: PropTypes.bool,
  isLast: PropTypes.bool,
  completeOpacity: PropTypes.string,
  activeOpacity: PropTypes.string,
  defaultOpacity: PropTypes.string,
  completeTitleOpacity: PropTypes.string,
  activeTitleOpacity: PropTypes.string,
  defaultTitleOpacity: PropTypes.string,
  barStyle: PropTypes.string,
  defaultBarColor: PropTypes.string,
  completeBarColor: PropTypes.string,
  defaultBorderColor: PropTypes.string,
  completeBorderColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  defaultBorderStyle: PropTypes.string,
  completeBorderStyle: PropTypes.string,
  activeBorderStyle: PropTypes.string,
  lineMarginOffset: PropTypes.number,
  defaultBorderWidth: PropTypes.number
};
